module.exports = __webpack_public_path__ + "img/anchorIndustry.62103b7c.svg";